import { FaPeopleGroup } from 'react-icons/fa6'

export default function BidBidderIcon({ isWhite }: any) {
  return (
    <FaPeopleGroup
      className={isWhite ? 'text-white' : 'text-bidfta-blue-light'}
    />
  )
}
